import React from 'react'
import PropTypes from 'prop-types'
import { Bar } from 'react-chartjs-2';

MixChart.propTypes = {
    heading: PropTypes.string,
    labels: PropTypes.array,
    data: PropTypes.array,
    height: PropTypes.number,
    legend: PropTypes.bool,
}
MixChart.defaultProps = {
    heading: '',
    labels: [],
    data: [],
    height: 50,
    legend: false,
};

function MixChart(props) {
    const mixedChartdata = {
        labels: props.labels, // props.labels - ovsGrades
        datasets: [{
          label: 'Average Score',
          type: 'line',
          data: props.linedata, // props.linedata - ovAvgScore
          fill: false,
          borderColor: '#F8BC4C',
          backgroundColor: '#F8BC4C',
          pointBorderColor: '#F8BC4C',
          pointBackgroundColor: '#F8BC4C',
          pointHoverBackgroundColor: '#F8BC4C',
          pointHoverBorderColor: '#F8BC4C',
          yAxisID: 'y-axis-2'
        }, {
          type: 'bar',
          label: 'Active Students',
          data: props.bar1data, // props.bardata  -  Student Count - ActiveStudentCount
          fill: false,
          backgroundColor: '#17bd59',
          borderColor: '#17bd59',
          hoverBackgroundColor: '#17bd59',
          hoverBorderColor: '#17bd59',
          yAxisID: 'y-axis-1'
        }, {
          type: 'bar',
          label: 'Inactive Students',
          data: props.bar2data, // props.bardata  -  Student Count - InactiveStudentCount
          fill: false,
          backgroundColor: '#e96969',
          borderColor: '#e96969',
          hoverBackgroundColor: '#e96969',
          hoverBorderColor: '#e96969',
          yAxisID: 'y-axis-1'
        }]
      };

      const mixedChartoptions = {
        // responsive: true,
        tooltips: {
          mode: 'label'
        },
        elements: {
          line: {
            fill: false
          }
        },
        maintainAspectRatio : false,
        scales: {
          xAxes: [
            {
              display: true,
              gridLines: {
                display: false
              },
              stacked: true,
              // labels: {
              //   show: true
              // },
              labels: props.labels, // props.labels - ovsGrades,
              scaleLabel: {
                display: true,
                labelString: 'Grade of the student (in school)'
              }
            }
          ],
          yAxes: [
            {
              type: 'linear',
              display: true,
              position: 'left',
              id: 'y-axis-1',
              stacked: true,
              gridLines: {
                display: false
              },
              labels: {
                show: true
              },
              scaleLabel: {
                display: true,
                labelString: 'Number of students'
              }
            },
            {
              type: 'linear',
              display: true,
              position: 'right',
              id: 'y-axis-2',
              gridLines: {
                display: false
              },
              labels: {
                show: true
              },
              scaleLabel: {
                display: true,
                labelString: 'Average score of the student (in percentage)'
              }
            }
          ]
        }
      };

      const plugins = [{
        afterDraw: (chartInstance, easing) => {
          // const ctx = chartInstance.chart.ctx;
          // ctx.fillText("This text drawn by a plugin", 100, 100);
        }
      }];

      let type;
      let lbl;
      function datasetbarClick(e){
        if(e[0] === undefined || e[0]._view.datasetLabel === undefined){
          console.log("test");
          // message.warning(‘no data’)
        } else {
        console.log(e);
        console.log(e[0]._view.datasetLabel);
        type = e[0]._view.datasetLabel;
        props.onbarTypClick(type)
        }
      }

      function barClick(e){
        if(e[0] === undefined || e[0]._view.datasetLabel === undefined){
          console.log("test");
          // message.warning(‘no data’)
        } else {
        console.log(e);
        console.log(e[0]);
        // var activePoint = e[0];
        // var data = activePoint._chart.data;
        // var datasetIndex = activePoint._datasetIndex;
        // var label = data.datasets[datasetIndex].label;
        // var value = data.datasets[datasetIndex].data[activePoint._index];
        // console.log(label,value);
        // console.log(e[1]._view.label,e[1]._view.datasetLabel)
        // console.log(e[2]._view.label)

        // console.log("LBL",label);
        console.log("e2",e[2])
        console.log("VAL",e[2]._view.label)
        lbl = e[2]._view.label;
        props.onbarGrdClick(lbl)
        }
       }


    return (
      
         // <article className="canvas-container1-mixed-bar">
             <Bar 
             data={mixedChartdata} 
             options={mixedChartoptions} 
             plugins={plugins} 
             height={props.height} 
             getDatasetAtEvent={(dataset) => datasetbarClick(dataset)}
            //  onElementsClick={barClick}
            getElementsAtEvent ={elems => barClick(elems)}
             />
          //</article>
      
    )
}

export default MixChart
